// @flow

import type {Action} from '../../types';
import type {SettingsStore} from '../types';

import {SET_MERCHANT_ID, SET_USER_TOKEN} from '../actions/settings';

const initialState: SettingsStore = {
  merchantID: 0
};

export default (state: SettingsStore = initialState, action: Action) => {
  switch (action.type) {
    case SET_MERCHANT_ID:
      return {
        ...state,
        merchantID: action.payload
      };
    case SET_USER_TOKEN:
      return {
        ...state,
        token: action.payload
      };
    default:
      return state;
  }
};
